import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '@core/services/auth.service';

/**
 * Auth Guard to protect routes requiring authentication
 * Usage: canActivate: [authGuard]
 */
export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  console.log(`🛡️ Auth Guard checking route: ${state.url}`);

  if (authService.isAuthenticated()) {
    return true;
  }

  // Store the attempted URL for redirecting after login
  const returnUrl = state.url;
  console.log('User not authenticated. Redirecting to login. Return URL:', returnUrl);

  // Redirect to login - MSAL will handle the redirect
  authService.login();
  
  return false;
};

/**
 * Role-based guard factory
 * Usage: canActivate: [roleGuard(['Admin', 'Manager'])]
 */
export function roleGuard(allowedRoles: string[]): CanActivateFn {
  return (route, state) => {
    const authService = inject(AuthService);
    const router = inject(Router);

    if (!authService.isAuthenticated()) {
      authService.login();
      return false;
    }

    const user = authService.getUser();
    const hasRequiredRole = allowedRoles.some(role => authService.hasRole(role));

    if (hasRequiredRole) {
      return true;
    }

    // User doesn't have required role - redirect to unauthorized page
    console.warn('User does not have required role:', allowedRoles);
    return router.createUrlTree(['/unauthorized']);
  };
}
